import { Component } from 'inferno';
import { observer } from 'inferno-mobx';
import { h } from 'inferno-hyperscript';
import { LakeInfoComponent } from './LakeInfoComponent';
import { DamInfoComponent } from './DamInfoComponent';
import { Search } from '../libs/Search';

function SvarLinkComponent() {
    return h('div.svarlink', [
        h('a', {
            target: '_blank',
            href: '/ladda-ner-data-svenskt-vattenarkiv'
        }, 'Ladda ner data från Svenskt Vattenarkiv')
    ]);
}

function AccessibilityLinkComponent() {
    return h('div.accessibilitylink', [
        h('a', {
            target: '_blank',
            href: '/tillgänglighetsredogörelse'
        }, 'Tillgänglighetsredogörelse för SMHI Vattenwebb')
    ]);
}


function SearchBox(props) {
    return h('div.search_panel', {
        title: props.title,
        role: 'search'
    }, [
        h('input.searchField', {
            type: 'text',
            name: 'search',
            ref: dom => {
                const searchBox = new Search(props.map, dom, props.register);
                searchBox.init();
            }
        })
    ]);
}


class DamComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return h('div', { className: this.props.hide ? 'hide' : '' }, [
            h(SearchBox, { title: 'Sök damm på id eller namn', map: this.props.map, register: 'dam' }),
            h(DamInfoComponent),
            h(SvarLinkComponent)
        ]);
    }
}

class LakeComponent extends Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        return h('div', { className: this.props.hide ? 'hide' : '' }, [
            h('div', [
                'Zooma in och klicka på en sjö för att få reda på dess information. För de sjöar som har utlopp markerade med en nedladdningssymbol finns digitala sjökartor att ladda ner.'
            ]),
            h(SearchBox, { title: 'Sök sjö på id eller namn', map: this.props.map, register: 'lake' }),
            h(LakeInfoComponent),
            h(SvarLinkComponent)
        ]);
    }
}

const RightColumnComponent = observer((props) => {
    const mode = STATE.mode;

    return [
        h(LakeComponent, { hide: mode !== 'lake', map: props.map }),
        h(DamComponent, { hide: mode !== 'dam', map: props.map }),
        h(AccessibilityLinkComponent)
    ];
});

export { RightColumnComponent };
